/**
 * This is a global component. It is instantiated only once (inside ReactPageWrapper).
 * In order to display the modal you should dispatch the showModal method and pass the data
 * that will be displayed inside the modal.
 *
 * UPDATE: This component originally used a modal from react-bootstrap, that was replaced with our ui-connect Dialog component in order remove react-bootstrap from our dependencies
 * DEPRECATED: Moving forward it would be best to use the ui-connect Dialog instead of this component
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getModalState } from '../reducers/modal/modal';
import { hideModal } from '../actions';
import { withTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogTitle } from 'ui-connect';

const mapStateToProps = (state) => ({
    modalState: getModalState(state)
});

class ModalComponent extends React.Component {
    hideModal() {
        const { modalState } = this.props;
        // to prevent showFooter becoming true onHide
        this.props.dispatch(hideModal({ showFooter: modalState.showFooter }));
    }

    onButtonClicked(btn) {
        const { modalState } = this.props;

        if (
            (btn !== 'onConfirmationClicked' ||
                (btn === 'onConfirmationClicked' && !modalState.confirmationButtonDisabled)) &&
            typeof modalState[btn] === 'function'
        ) {
            modalState[btn]();
        }

        if (btn === 'onConfirmationClicked') {
            if (!modalState.confirmationButtonDisabled) {
                this.hideModal();
            }
        } else {
            this.hideModal();
        }
    }

    render() {
        const { modalState, t } = this.props,
            {
                showFooter,
                view,
                title, // this should be a key that will get localized
                customTitle, // this should be an already localized string
                modalId,
                customClasses,
                customBodyClasses,
                showCloseButton,
                showCancelButton,
                cancelTextKey,
                confirmationTextKey,
                footerPrimaryButtonClasses,
                modalIsOpen,
                onConfirmationClicked,
                customFooterTemplate,
                confirmationButtonDisabled,
                backdropClassName,
                hideBorder,
                largeCloseBtn,
                stopClickPropagationOnModalClick
            } = modalState;

        let dialogWidth = 'medium';
        let dialogClasses = customClasses;

        // Set the ui-connect Dialog to the correct width based on the legacy modal's size options
        if (customClasses && customClasses.includes('modal-narrow')) {
            dialogWidth = 'small';
            dialogClasses = customClasses.replace('modal-narrow', '');
        } else if (customClasses && customClasses.includes('modal-wide')) {
            dialogWidth = 'large';
            dialogClasses = customClasses.replace('modal-wide', '');
        } else if (customClasses && customClasses.includes('modal-xLarge')) {
            dialogWidth = 'xLarge';
            dialogClasses = customClasses.replace('modal-xLarge', '');
        }

        return (
            <Dialog
                key={modalId}
                open={modalIsOpen}
                closeBtn={showCloseButton}
                width={dialogWidth}
                backdropClassName={backdropClassName}
                hideBorder={hideBorder}
                largeCloseBtn={largeCloseBtn}
                disableBackdropClick={stopClickPropagationOnModalClick}
                onClose={() => this.onButtonClicked('onCloseClicked')}
            >
                <div className={dialogClasses}>
                    {title || customTitle ? <DialogTitle>{title ? t(title) : customTitle}</DialogTitle> : null}

                    <DialogContent>
                        <div className={customBodyClasses}>{view}</div>
                    </DialogContent>

                    {customFooterTemplate ? (
                        <DialogActions>{customFooterTemplate}</DialogActions>
                    ) : showFooter ? (
                        <DialogActions>
                            {showCancelButton ? (
                                <a
                                    className="btn btn-secondary cancel"
                                    data-dismiss="modal"
                                    onClick={() => this.onButtonClicked('onCancelClicked')}
                                >
                                    {t(cancelTextKey)}
                                </a>
                            ) : null}
                            &nbsp;
                            {onConfirmationClicked ? (
                                <a
                                    className={`btn btn-primary js-saveBtn ${footerPrimaryButtonClasses}`}
                                    onClick={() => this.onButtonClicked('onConfirmationClicked')}
                                    disabled={confirmationButtonDisabled}
                                >
                                    {t(confirmationTextKey)}
                                </a>
                            ) : null}
                        </DialogActions>
                    ) : null}
                </div>
            </Dialog>
        );
    }
}

ModalComponent.defaultProps = {
    stopClickPropagationOnModalClick: false
};

ModalComponent.propTypes = {
    modalState: PropTypes.object.isRequired,
    showHeader: PropTypes.bool,
    showFooter: PropTypes.bool,
    view: PropTypes.string,
    title: PropTypes.string,
    customTitle: PropTypes.string,
    modalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    customClasses: PropTypes.string,
    customBodyClasses: PropTypes.string,
    showCloseButton: PropTypes.bool,
    showCancelButton: PropTypes.bool,
    cancelTextKey: PropTypes.string,
    confirmationTextKey: PropTypes.string,
    footerPrimaryButtonClasses: PropTypes.string,
    modalIsOpen: PropTypes.bool,
    onConfirmationClicked: PropTypes.func,
    confirmationButtonDisabled: PropTypes.bool,
    backdropClassName: PropTypes.string,
    stopClickPropagationOnModalClick: PropTypes.bool
};

export default withTranslation(['main_container'])(connect(mapStateToProps)(ModalComponent));
